import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonsModule } from 'src/app/common/common.module';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Daterangepicker } from 'ng2-daterangepicker';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { HomeFooterComponent } from './common/homeFooter/homeFooter.component';
import { SearchbarComponent } from './searchbar/searchbar.component';
import { ExclusiveComponent } from './exclusive-deals/exclusiveDeals.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { AvailbilityComponent } from './availbility/availbility.component';
import { SSOComponent } from './agentlogin/sso.component';
import { ModifySearchComponent } from './availbility/modify-search/modifySearch.component';
import { EnquiryComponent } from './templates/enquiry-success.component';
import { BookingReportComponent } from './reports/bookingReport.component';
import { AgentDashBoardComponent } from './agentdashboard/agentdashboard.component';
import { AdminLoginComponent } from './agentdashboard/adminlogin.component';
import { RemoveCacheComponent } from './remove-cache/remove-cache.component';
import { CruiseItineraryComponent } from './reports/cruise-itinerary.component';
import { VoucherComponent } from './templates/cruise-voucher.component';
import { CruiseDetailsComponent } from './availbility/cruisedetails.component';
import { from } from 'rxjs';
import { LoadingModalComponent } from './common/loading-modal/loading-modal.component';
import { GalleryComponent } from './availbility/gallery/gallery.component';
import { MatDialogModule } from '@angular/material/dialog';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { GenericComponent } from './subscription/generic.component';
import { RechargeComponent } from './recharge/recharge.component';
import { RechargeHomeComponent } from './recharge/rechargehome.component';
import { BannerComponent } from './recharge/banner.component';
import { RechargeB2CComponent } from './recharge/rechargeb2c.component';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HomeFooterComponent,
    SearchbarComponent,
    ExclusiveComponent,
    SubscriptionComponent,
    AvailbilityComponent,
    SSOComponent,
    ModifySearchComponent,
    EnquiryComponent,
    BookingReportComponent, AgentDashBoardComponent, AdminLoginComponent, RemoveCacheComponent, CruiseItineraryComponent,
    VoucherComponent, CruiseDetailsComponent,
    LoadingModalComponent, GenericComponent, RechargeComponent, RechargeHomeComponent, BannerComponent, RechargeB2CComponent,
    GalleryComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    CommonsModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    Daterangepicker,
    ToastrModule.forRoot(),
    MatIconModule,
    FlexLayoutModule,
    MatDialogModule
  ],
  providers: [
    HttpClientModule
  ],
  bootstrap: [AppComponent],
  exports: [
    ModifySearchComponent
  ]
})
export class AppModule { }
